import React, { createContext, useEffect, useState } from "react";

import { AuthSessionManager } from "../auth/AuthSessionManager";

export const AccessGateContext = createContext();

export const AccessGateProvider = ({ children }) => {
  const [userData, setUserData] = useState({});

  const [canAccessVendorArea, setCanAccessVendorArea] = useState(() => {
    try {
      const boot = AuthSessionManager.bootstrap();
      return Boolean(boot?.token);
    } catch {
      return false;
    }
  });

  const allowVendorAreaAccess = () => setCanAccessVendorArea(true);

  useEffect(() => {
    const syncFromAuth = () => {
      const boot = AuthSessionManager.bootstrap();
      setCanAccessVendorArea(Boolean(boot?.token));
    };

    window.addEventListener("wcp:auth:change", syncFromAuth);
    window.addEventListener("wcp:auth:logout", syncFromAuth);
    return () => {
      window.removeEventListener("wcp:auth:change", syncFromAuth);
      window.removeEventListener("wcp:auth:logout", syncFromAuth);
    };
  }, []);

  return (
    <AccessGateContext.Provider
      value={{
        canAccessVendorArea,
        allowVendorAreaAccess,
        userData,
        setUserData,
      }}
    >
      {children}
    </AccessGateContext.Provider>
  );
};

export function useAccessGate() {
  const ReactUseContext = React.useContext;
  return ReactUseContext(AccessGateContext);
}

